export default import.meta.ROLLDOWN_FILE_URL_C8FZTB9KZW61b1q05gBpPw